export const apiURL = process.env.REACT_APP_API_URL || "";
export const apiKey = process.env.REACT_APP_API_KEY || "";
export const baseURL = process.env.REACT_APP_BASE_URL || "";